import React, {
  createContext,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useState,
} from 'react';

export const LANGUAGES = [
  { code: 'ru', label: 'RU', name: 'Русский' },
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'kk', label: 'KZ', name: 'Қазақша' },
];

const STORAGE_KEY = 'medeo-language';

const translations = {
  ru: {
    brand: {
      madeWithSoul: 'сделано с душой',
      footerTagline: 'Уральская компания пищевой консервации',
      companyName: 'Медео',
    },
    nav: {
      products: 'Продукция',
      company: 'О компании',
      documents: 'Документы',
      contacts: 'Контакты',
      catalog: 'Каталог',
      phone: 'Телефон',
      allCatalog: 'Весь каталог',
      alreadyHere: 'Вы уже здесь',
      mainNavigation: 'Основная навигация',
      mobileNavigation: 'Мобильная навигация',
      quickNavigation: 'Быстрая навигация',
      openMenu: 'Открыть меню',
      chooseLanguage: 'Выбор языка',
    },
    buttons: {
      viewProducts: 'Смотреть продукцию',
      details: 'Подробнее',
      download: 'Скачать',
      fullscreen: 'На весь экран',
      print: 'Печать',
      close: 'Закрыть',
    },
    home: {
      heroEyebrow: 'Челябинская область • с 1998 года',
      heroText:
        'Соусы, пасты, горчица и уксусы для домашней кухни, розницы и стабильных поставок. Честный вкус, понятный состав, документы на каждую линейку.',
      heroFactsLabel: 'Ключевые факты',
      metricLines: 'линеек продукции',
      metricDocs: 'и декларации',
      metricCountries: 'страны поставок',
      categoriesLabel: 'Категории продукции',
      productsEyebrow: 'Продукция',
      productsTitle: 'Вкус, который легко поставить на полку',
      productsText:
        'Линейка закрывает базовые сценарии кухни: томатная основа, острые приправы, маринады, соусы и консервация.',
      companyEyebrow: 'О компании',
      companyTitle: 'Уральское производство с характером домашней кухни',
      companyTextOne:
        '«Медео» больше 20 лет выпускает продукты пищевой консервации. История началась с аджики, а затем выросла в линейку горчицы, уксусов, томатной пасты и кетчупа.',
      companyTextTwo:
        'Мы сохраняем узнаваемый вкус и усиливаем контроль качества: работаем с проверенным сырьем, следим за стабильностью партий и поддерживаем ассортимент, который понятен покупателю.',
      companyImageAlt: 'Ингредиенты Медео',
      companyPanelTitle: 'Сделано с душой',
      companyPanelText: 'без лишнего шума, с фокусом на продукт',
      reasonsEyebrow: 'Почему выбирают',
      reasonsTitle: 'Для партнеров важны вкус, документы и предсказуемость',
      documentsEyebrow: 'Документы',
      documentsTitle: 'Все основное для проверки качества',
      contactsEyebrow: 'Контакты',
      contactsTitle: 'Связаться с производством',
      addressLabel: 'Адрес',
      phoneLabel: 'Телефон',
      emailLabel: 'Email',
      address:
        'Россия, Челябинская область, г. Копейск, посёлок Железнодорожный, Высоковольтная ул., 2А',
      documents: {
        declaration: 'Декларация',
        certificate: 'Сертификат',
      },
      advantages: [
        {
          value: '20+',
          label: 'лет на рынке',
          text: 'Уральское производство пищевой консервации с устойчивым ассортиментом.',
        },
        {
          value: 'ГОСТ',
          label: 'контроль партии',
          text: 'Документы и проверка качества сопровождают каждую продуктовую линейку.',
        },
        {
          value: 'РФ + KZ',
          label: 'география поставок',
          text: 'Работаем с партнерами по России и Казахстану, соблюдаем сроки отгрузки.',
        },
      ],
      reasons: [
        {
          title: 'Собственный вкус',
          text: 'Рецептуры построены вокруг натурального томатного сырья, специй, чеснока и чистой кислоты без лишней декоративности.',
        },
        {
          title: 'Цены без посредников',
          text: 'Производственная модель помогает держать понятные условия для розницы, опта и регулярных поставок.',
        },
        {
          title: 'Документы на виду',
          text: 'Сертификаты и декларации доступны прямо на сайте, чтобы решение о закупке было проще и быстрее.',
        },
      ],
    },
    catalog: {
      eyebrow: 'Каталог Медео',
      title: 'Продукты для полки, кухни и стабильных поставок',
      text:
        'Подробная линейка с фасовками, сроками годности, составом и пищевой ценностью. Нажмите на нужную позицию в шапке или пролистайте каталог.',
      shelfLife: 'Срок годности',
      composition: 'Состав',
      nutrition: 'Пищевая ценность на 100 г',
      proteins: 'Белки',
      carbs: 'Углеводы',
      qualityEyebrow: 'Контроль качества',
      qualityTitle:
        'Производим по ГОСТ и сопровождаем продукцию документами',
    },
  },
  en: {
    brand: {
      madeWithSoul: 'made with soul',
      footerTagline: 'Ural food preservation company',
      companyName: 'Medeo',
    },
    nav: {
      products: 'Products',
      company: 'Company',
      documents: 'Documents',
      contacts: 'Contacts',
      catalog: 'Catalog',
      phone: 'Phone',
      allCatalog: 'Full catalog',
      alreadyHere: 'You are already here',
      mainNavigation: 'Main navigation',
      mobileNavigation: 'Mobile navigation',
      quickNavigation: 'Quick navigation',
      openMenu: 'Open menu',
      chooseLanguage: 'Language',
    },
    buttons: {
      viewProducts: 'View products',
      details: 'Details',
      download: 'Download',
      fullscreen: 'Full screen',
      print: 'Print',
      close: 'Close',
    },
    home: {
      heroEyebrow: 'Chelyabinsk region • since 1998',
      heroText:
        'Sauces, pastes, mustard, and vinegars for home kitchens, retail shelves, and stable supply. Honest taste, clear ingredients, and documents for every product line.',
      heroFactsLabel: 'Key facts',
      metricLines: 'product lines',
      metricDocs: 'and declarations',
      metricCountries: 'supply countries',
      categoriesLabel: 'Product categories',
      productsEyebrow: 'Products',
      productsTitle: 'Taste that is easy to put on the shelf',
      productsText:
        'The range covers core kitchen scenarios: tomato base, spicy condiments, marinades, sauces, and preserves.',
      companyEyebrow: 'About company',
      companyTitle: 'Ural production with a home-kitchen character',
      companyTextOne:
        'Medeo has been producing food preservation products for more than 20 years. The story began with adjika and grew into a range of mustard, vinegars, tomato paste, and ketchup.',
      companyTextTwo:
        'We preserve a recognizable taste and strengthen quality control: we work with trusted raw materials, monitor batch stability, and maintain a range that is clear to buyers.',
      companyImageAlt: 'Medeo ingredients',
      companyPanelTitle: 'Made with soul',
      companyPanelText: 'focused on the product, without unnecessary noise',
      reasonsEyebrow: 'Why partners choose us',
      reasonsTitle: 'Partners value taste, documents, and predictability',
      documentsEyebrow: 'Documents',
      documentsTitle: 'Everything essential for quality checks',
      contactsEyebrow: 'Contacts',
      contactsTitle: 'Contact production',
      addressLabel: 'Address',
      phoneLabel: 'Phone',
      emailLabel: 'Email',
      address:
        'Russia, Chelyabinsk region, Kopeysk, Zheleznodorozhny settlement, Vysokovoltnaya St., 2A',
      documents: {
        declaration: 'Declaration',
        certificate: 'Certificate',
      },
      advantages: [
        {
          value: '20+',
          label: 'years in market',
          text: 'Ural food preservation production with a stable product range.',
        },
        {
          value: 'GOST',
          label: 'batch control',
          text: 'Documents and quality checks support every product line.',
        },
        {
          value: 'RU + KZ',
          label: 'supply geography',
          text: 'We work with partners in Russia and Kazakhstan and keep shipment schedules predictable.',
        },
      ],
      reasons: [
        {
          title: 'Own taste',
          text: 'Recipes are built around natural tomato raw material, spices, garlic, and clean acidity without unnecessary decoration.',
        },
        {
          title: 'Direct pricing',
          text: 'The production model helps keep terms clear for retail, wholesale, and regular supply.',
        },
        {
          title: 'Documents in sight',
          text: 'Certificates and declarations are available on the website, making purchasing decisions faster and easier.',
        },
      ],
    },
    catalog: {
      eyebrow: 'Medeo Catalog',
      title: 'Products for shelves, kitchens, and stable supply',
      text:
        'A detailed range with pack sizes, shelf life, ingredients, and nutrition facts. Choose a product in the header or scroll through the catalog.',
      shelfLife: 'Shelf life',
      composition: 'Ingredients',
      nutrition: 'Nutrition per 100 g',
      proteins: 'Proteins',
      carbs: 'Carbohydrates',
      qualityEyebrow: 'Quality control',
      qualityTitle:
        'We manufacture according to GOST and support products with documents',
    },
  },
  kk: {
    brand: {
      madeWithSoul: 'шын көңілмен жасалған',
      footerTagline: 'Орал тағам консервілеу компаниясы',
      companyName: 'Медео',
    },
    nav: {
      products: 'Өнімдер',
      company: 'Компания',
      documents: 'Құжаттар',
      contacts: 'Байланыс',
      catalog: 'Каталог',
      phone: 'Телефон',
      allCatalog: 'Толық каталог',
      alreadyHere: 'Сіз осындасыз',
      mainNavigation: 'Негізгі навигация',
      mobileNavigation: 'Мобильді навигация',
      quickNavigation: 'Жылдам навигация',
      openMenu: 'Мәзірді ашу',
      chooseLanguage: 'Тілді таңдау',
    },
    buttons: {
      viewProducts: 'Өнімдерді көру',
      details: 'Толығырақ',
      download: 'Жүктеп алу',
      fullscreen: 'Толық экран',
      print: 'Басып шығару',
      close: 'Жабу',
    },
    home: {
      heroEyebrow: 'Челябинск облысы • 1998 жылдан бері',
      heroText:
        'Үй асханасына, бөлшек саудаға және тұрақты жеткізілімге арналған тұздықтар, пасталар, қыша және сірке сулары. Адал дәм, түсінікті құрам, әр өнім желісіне құжаттар.',
      heroFactsLabel: 'Негізгі деректер',
      metricLines: 'өнім желісі',
      metricDocs: 'және декларациялар',
      metricCountries: 'жеткізу елі',
      categoriesLabel: 'Өнім санаттары',
      productsEyebrow: 'Өнімдер',
      productsTitle: 'Сөреге қоюға оңай дәм',
      productsText:
        'Желі ас үйдің негізгі сценарийлерін жабады: томат негізі, ащы дәмдеуіштер, маринадтар, тұздықтар және консервілеу.',
      companyEyebrow: 'Компания туралы',
      companyTitle: 'Үй асханасының мінезі бар Орал өндірісі',
      companyTextOne:
        '«Медео» 20 жылдан астам уақыт тағам консервілеу өнімдерін шығарады. Тарих аджикадан басталып, кейін қыша, сірке сулары, томат пастасы және кетчуп желісіне ұласты.',
      companyTextTwo:
        'Біз танымал дәмді сақтап, сапа бақылауын күшейтеміз: тексерілген шикізатпен жұмыс істейміз, партия тұрақтылығын қадағалаймыз және сатып алушыға түсінікті ассортиментті қолдаймыз.',
      companyImageAlt: 'Медео ингредиенттері',
      companyPanelTitle: 'Шын көңілмен жасалған',
      companyPanelText: 'артық шу жоқ, назар өнімде',
      reasonsEyebrow: 'Неге таңдайды',
      reasonsTitle: 'Серіктестер үшін дәм, құжаттар және болжамдылық маңызды',
      documentsEyebrow: 'Құжаттар',
      documentsTitle: 'Сапаны тексеруге қажет негізгі құжаттар',
      contactsEyebrow: 'Байланыс',
      contactsTitle: 'Өндіріспен байланысу',
      addressLabel: 'Мекенжай',
      phoneLabel: 'Телефон',
      emailLabel: 'Email',
      address:
        'Ресей, Челябинск облысы, Копейск қ., Железнодорожный кенті, Высоковольтная көш., 2А',
      documents: {
        declaration: 'Декларация',
        certificate: 'Сертификат',
      },
      advantages: [
        {
          value: '20+',
          label: 'нарықтағы жыл',
          text: 'Тұрақты ассортименті бар Орал тағам консервілеу өндірісі.',
        },
        {
          value: 'ГОСТ',
          label: 'партия бақылауы',
          text: 'Құжаттар мен сапа тексерісі әр өнім желісін сүйемелдейді.',
        },
        {
          value: 'RU + KZ',
          label: 'жеткізу географиясы',
          text: 'Ресей және Қазақстан серіктестерімен жұмыс істейміз, жөнелту мерзімдерін сақтаймыз.',
        },
      ],
      reasons: [
        {
          title: 'Өзіндік дәм',
          text: 'Рецептура табиғи томат шикізатына, дәмдеуіштерге, сарымсаққа және таза қышқылдыққа негізделген.',
        },
        {
          title: 'Делдалсыз бағалар',
          text: 'Өндірістік модель бөлшек сауда, көтерме және тұрақты жеткізілім үшін түсінікті шарттарды ұстауға көмектеседі.',
        },
        {
          title: 'Құжаттар ашық',
          text: 'Сертификаттар мен декларациялар сайтта қолжетімді, сондықтан сатып алу туралы шешім жылдамырақ қабылданады.',
        },
      ],
    },
    catalog: {
      eyebrow: 'Медео каталогы',
      title: 'Сөре, ас үй және тұрақты жеткізілімге арналған өнімдер',
      text:
        'Қаптамалары, сақтау мерзімі, құрамы және тағамдық құндылығы көрсетілген толық желі. Қажетті позицияны шапкадан таңдаңыз немесе каталогты төмен қарай қараңыз.',
      shelfLife: 'Сақтау мерзімі',
      composition: 'Құрамы',
      nutrition: '100 г өнімнің тағамдық құндылығы',
      proteins: 'Ақуыздар',
      carbs: 'Көмірсулар',
      qualityEyebrow: 'Сапа бақылауы',
      qualityTitle:
        'ГОСТ бойынша өндіреміз және өнімді құжаттармен сүйемелдейміз',
    },
  },
};

const I18nContext = createContext(null);

function getValue(dictionary, path) {
  return path.split('.').reduce((value, part) => {
    if (value && Object.prototype.hasOwnProperty.call(value, part)) {
      return value[part];
    }

    return undefined;
  }, dictionary);
}

function interpolate(value, params) {
  if (!params || typeof value !== 'string') return value;

  return Object.entries(params).reduce(
    (current, [key, replacement]) =>
      current.replaceAll(`{${key}}`, String(replacement)),
    value
  );
}

function getInitialLanguage() {
  if (typeof window === 'undefined') return 'ru';

  const savedLanguage = window.localStorage.getItem(STORAGE_KEY);
  if (LANGUAGES.some((language) => language.code === savedLanguage)) {
    return savedLanguage;
  }

  return 'ru';
}

export function LanguageProvider({ children }) {
  const [language, setLanguageState] = useState(getInitialLanguage);

  useEffect(() => {
    window.localStorage.setItem(STORAGE_KEY, language);
    document.documentElement.lang = language;
  }, [language]);

  const setLanguage = useCallback((nextLanguage) => {
    if (!LANGUAGES.some((languageItem) => languageItem.code === nextLanguage)) {
      return;
    }

    if (nextLanguage === language) {
      return;
    }

    setLanguageState(nextLanguage);
  }, [language]);

  const t = useCallback(
    (key, params) => {
      const value =
        getValue(translations[language], key) ?? getValue(translations.ru, key) ?? key;
      return interpolate(value, params);
    },
    [language]
  );

  const value = useMemo(
    () => ({
      language,
      languages: LANGUAGES,
      setLanguage,
      t,
    }),
    [language, setLanguage, t]
  );

  return <I18nContext.Provider value={value}>{children}</I18nContext.Provider>;
}

export function useI18n() {
  const value = useContext(I18nContext);

  if (!value) {
    throw new Error('useI18n must be used inside LanguageProvider');
  }

  return value;
}
